import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dhd-loading-spinner',
  templateUrl: './dhd-loading-spinner.component.html',
  styleUrls: ['./dhd-loading-spinner.component.scss']
})
export class DhdLoadingSpinnerComponent implements OnInit {

  @Input() diameter = 36;
  constructor() { }

  ngOnInit() {
  }

}
